export enum LINK_THEMES {
    DEFAULT = 'default',
    GREEN = 'green',
    TINY = 'black'
}
